import UI from "./base/UI";

/**
 * Observer
 */

/*
    1. 화면에 보여야할 타겟에 class="ui-observer" 추가
    2. 타겟의 자식중 addClass 주고싶은 자식에게 data-observer-class="적용하고 싶은 class"을 입력.
    3. show(callback)
    
 */
 class Observer extends UI {
    constructor(el) {
        super('observer', el);
        this.init(el);
    }

    init(el) {
        const threshold = ( +el.dataset.threshold || 10 ) / 100;
        const observer = new IntersectionObserver((enteries, observer) => {
            enteries.forEach(({ target, isIntersecting } ) => {
                if( isIntersecting ){
                    const children = $( target ).find( "[data-observer-class]" );
                    children.each((_, item) => {
                        const { observerClass } = item.dataset;
                        item.classList.add( observerClass );
                    });

                    this.callback && this.callback();
                    observer.unobserve(target)
                }
            });
        }, {
            threshold: threshold
        });

        observer.observe(el);
    }

    show( callback ){
        this.callback = callback;
    }
}

export default Observer;
